import axios from 'axios';

const SEARCH_PNR_URI = '/checkout/api/v2/booking/search';

export function search(searchPNRModel) { 
  return new Promise((resolve, reject) => {
    const payload = {
			items: {
				cpfOrTa: searchPNRModel.cpf,
				pnr: ""
			}
		};
    axios
      .post(SEARCH_PNR_URI, payload)
      .then(res => resolve(res))
      .catch(err => {
        reject(err);
      });
  });
}


// WEBPACK FOOTER //
// ./src/services/searchPNR/SearchPNRService.js